import { ModalContent } from "@atoms/modal/modal";

export const TableOptionsModal = () => {
  return <ModalContent title="Options" />;
};
